import React from 'react';
import styles from './GrowthBenefits.module.css';
import { Row, Col } from 'reactstrap';
import GrowthBanner from '../../assets/images/Vendor/Trane/GrowthImageBanner.jpeg';

const GrowthBenefits = () => {

    return (
        <Row className={styles.growthBenefitsContainer}>
            <Col className={styles.growthDescriptionContainer} md="12" lg="6" >
                <h1>ComfortSure</h1>
                <h2>Promoting Dealer Growth and Profitability</h2>
                <p>
                    ComfortSure Extended Service Agreements (ESAs) can help elevate your business to the next level. 
                    When customers purchase labor coverage with their product installation, 
                    you increase profits without overhead costs while creating opportunities to build a relationship 
                    with your customer through the plan duration.  
                </p>
            </Col>
            <Col className={styles.growthImageContainer} md="12" lg="6">
                <img
                    src={GrowthBanner}
                    alt="Growth Image Banner"
                />
            </Col>
        </Row>
    );
}

export default GrowthBenefits;